// reducer.js
import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  ADD_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  FETCH_PENDING_VENDORS_REQUEST,
  FETCH_PENDING_VENDORS_SUCCESS,
  FETCH_PENDING_VENDORS_FAILURE,
  APPROVE_VENDOR_REQUEST,
  APPROVE_VENDOR_SUCCESS,
  APPROVE_VENDOR_FAILURE,
} from './actionTypes'

const initialState = {
  users: [],
  pendingVendors: [],
  loading: false,
  error: null,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
      }
    case FETCH_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case FETCH_PENDING_VENDORS_REQUEST:
    case APPROVE_VENDOR_REQUEST:
    case ADD_USER_REQUEST:
    case UPDATE_USER_REQUEST:
    case DELETE_USER_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_PENDING_VENDORS_SUCCESS:
      return {
        ...state,
        loading: false,
        pendingVendors: action.payload,
      }
    case FETCH_PENDING_VENDORS_FAILURE:
    case APPROVE_VENDOR_FAILURE:
    case ADD_USER_FAILURE:
    case UPDATE_USER_FAILURE:
    case DELETE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case APPROVE_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        pendingVendors: {
          ...state.pendingVendors,
          data: state.pendingVendors.data?.filter(item => item?._id !== action.payload)
        }
      }
    case ADD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users:{...state?.users, data:[...state.users.data,action.payload?.data]}
      }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users:{...state?.users,data:state.users.data?.map(item=>item?._id == action.payload?.data?._id ? action.payload.data :item)}
      }
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users:{...state?.users,data:state.users.data?.filter(item=>item?._id != action.payload?.data?._id)}
      }
    default:
      return state
  }
}

export default userReducer
